;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:propstrata-app":true});}catch(e){}}();import type {
	Prisma,
	ProviderType,
	WorkflowTriggerType,
} from "@/prisma/generated/client";

export enum SuccessAction {
	UPDATE_WORKFLOW_STATUS = "UPDATE_WORKFLOW_STATUS",
}

export enum WorkflowOperator {
	EQUALS = "==",
	NOT_EQUALS = "!=",
	GREATER_THAN = ">",
	LESS_THAN = "<",
	GREATER_THAN_OR_EQUALS = ">=",
	LESS_THAN_OR_EQUALS = "<=",
}

export enum WorkflowStatus {
	ACTIVE = "ACTIVE",
	INACTIVE = "INACTIVE",
	DRAFT = "DRAFT",
}

export enum WorkflowStepType {
	NOTIFICATION = "NOTIFICATION",
	API_CALL = "API_CALL",
	DATA_UPDATE = "DATA_UPDATE",
	APPROVAL = "APPROVAL",
	CONDITION = "CONDITION",
	DELAY = "DELAY",
	CUSTOM = "CUSTOM",
}

export enum WorkflowNotificationPreference {
	ALL_STEPS = "ALL_STEPS",
	COMPLETION_ONLY = "COMPLETION_ONLY",
	FAILURES_ONLY = "FAILURES_ONLY",
	APPROVALS_ONLY = "APPROVALS_ONLY",
	CUSTOM = "CUSTOM",
}

export enum WorkflowNotificationType {
	EMAIL = "EMAIL",
	SMS = "SMS",
	PUSH = "PUSH",
}

export enum WorkflowNotificationStatus {
	PENDING = "PENDING",
	SENT = "SENT",
	FAILED = "FAILED",
	READ = "READ",
	VIEWED = "VIEWED",
	CLOSED = "CLOSED",
}

export enum WorkflowExecutionStatus {
	PENDING = "PENDING",
	RUNNING = "RUNNING",
	COMPLETED = "COMPLETED",
	FAILED = "FAILED",
	CANCELLED = "CANCELLED",
}

export enum WorkflowStepExecutionStatus {
	PENDING = "PENDING",
	IN_PROGRESS = "IN_PROGRESS",
	COMPLETED = "COMPLETED",
	SKIPPED = "SKIPPED",
	WAITING_APPROVAL = "WAITING_APPROVAL",
	FAILED = "FAILED",
}

export enum WorkflowStepExecutionResult {
	SUCCESS = "SUCCESS",
	FAILED = "FAILED",
}

export enum WorkflowStepExecutionError {
	TIMEOUT = "TIMEOUT",
	FAILED = "FAILED",
	APPROVED = "APPROVED",
	REJECTED = "REJECTED",
}

export enum ExecutionStatus {
	PENDING = "PENDING",
	RUNNING = "RUNNING",
	COMPLETED = "COMPLETED",
	FAILED = "FAILED",
	CANCELLED = "CANCELLED",
}

export interface WorkflowStep {
	id?: string;
	name: string;
	description?: string;
	stepType: WorkflowStepType;
	stepConfig: {
		templateId?: string;
		approvers?: string[];
		url?: string;
		schedule?: string;
		endpoint?: string;
		[key: string]: unknown;
	};
	order: number;
	isRequired: boolean;
	timeout?: number;
	retryConfig?: {
		maxRetries?: number;
		retryDelay?: number;
		backoff?: boolean;
		[key: string]: unknown;
	};
	dependencies?: string[];
	metadata?: WorkflowMetadata;
}

export interface WorkflowSubscriber {
	id?: string;
	userId: string;
	notifyPreference: WorkflowNotificationPreference;
	customPreferences?: {
		[key: string]: unknown;
	};
}

export interface WorkflowCondition {
	field: string;
	operator: WorkflowOperator;
	value: string | number;
}

export interface WorkflowTriggerConfig {
	conditions?: WorkflowCondition[];
	schedule?: string;
	endpoint?: string;
	[key: string]: unknown;
}

export interface Workflow {
	id?: string;
	name: string;
	description: string;
	triggerType: WorkflowTriggerType;
	triggerConfig: WorkflowTriggerConfig;
	status: WorkflowStatus;
	workspaceId: string;
	createdById: string;
	steps: WorkflowStep[];
	subscribers?: WorkflowSubscriber[];
	metadata?: WorkflowMetadata;
}

export interface WorkflowExecution {
	id?: string;
	workflowId: string;
	status: WorkflowExecutionStatus;
	startedAt: Date;
	completedAt?: Date;
	triggeredById?: string;
	triggerData?: {
		[key: string]: unknown;
	};
	error?: string;
	metadata?: {
		[key: string]: unknown;
	};
}

export interface StepExecution {
	id?: string;
	executionId: string;
	stepId: string;
	status: WorkflowStepExecutionStatus;
	startedAt: Date;
	completedAt?: Date;
	result?: {
		[key: string]: unknown;
	};
	error?: string;
	approvedById?: string;
	approvedAt?: Date;
	retryCount: number;
}

export interface WorkflowNotification {
	id: string;
	workflowId: string;
	subscriberId: string;
	type: WorkflowNotificationType;
	status: WorkflowNotificationStatus;
	content: string;
	metadata?: {
		[key: string]: unknown;
	};
	sentAt?: Date;
	readAt?: Date;
	error?: string;
	createdAt?: Date;
}

export interface CreateWorkflowInput {
	name: string;
	description: string;
	triggerType: WorkflowTriggerType;
	triggerConfig: WorkflowTriggerConfig;
	workspaceId: string;
	steps: WorkflowStep[];
	subscribers?: WorkflowSubscriber[];
	status?: WorkflowStatus;
	viewId?: string;
	viewName?: string;
	visualizationId?: string;
}

export interface UpdateWorkflowInput {
	name?: string;
	description?: string;
	triggerType?: WorkflowTriggerType;
	triggerConfig?: WorkflowTriggerConfig;
	status?: WorkflowStatus;
	steps?: WorkflowStep[];
	subscribers?: WorkflowSubscriber[];
}

export interface ExecuteWorkflowInput {
	workflowId: string;
	triggerData?: {
		[key: string]: unknown;
	};
	metadata?: {
		[key: string]: unknown;
	};
}

export interface WorkflowExecutionResult {
	workflow: Workflow;
	execution: WorkflowExecution;
	stepExecutions: StepExecution[];
}

export interface WorkflowMetadata {
	viewId?: string;
	viewName?: string;
	visualizationId?: string;
}

export type WorkflowViewVisualization = Prisma.ViewVisualizationGetPayload<{
	include: {
		view: {
			select: {
				workspaceId: true;
				id: true;
				name: true;
				workspace: {
					select: {
						name: true;
					};
				};
			};
		};
		visualization: {
			select: {
				name: true;
				group: {
					select: {
						dataSourceConfigs: {
							select: {
								id: true;
								sourceType: true;
								sourceConfig: true;
								urlPath: true;
								provider: true;
							};
						};
					};
				};
			};
		};
	};
}>;

export interface WorkflowStepConfig {
	viewId?: string;
	viewName?: string;
	workspaceId?: string;
	dataSourceId?: string;
	visualizationId?: string;
	viewVisualizationId?: string;
	viewVisualizationGroupId?: string;
	workflowDescription?: string;
	onSuccess?: SuccessAction;
	groupId?: string;
	action?: string;
	providerType?: ProviderType;
	dataProviderId?: string;
}

export interface TypedWorkflowStep extends Omit<WorkflowStep, "stepConfig"> {
	stepConfig: WorkflowStepConfig;
	workflowId: string;
	workflowExecutionId: string;
}

export interface CreateWorkflowData {
	viewVisualization: WorkflowViewVisualization;
	userId: string;
	workflowTriggerType?: WorkflowTriggerType;
	workflowName?: string;
	workflowDescription?: string;
}

export interface GenerateWorkflowStepsInput {
	workflowName: string;
	workflowDescription: string;
	viewVisualization: WorkflowViewVisualization;
	userId: string;
	workflowTriggerType: WorkflowTriggerType;
}

export interface GenerateWorkspaceWorkflowStepsInput {
	workspaceId: string;
	workspaceName: string;
	providerType: ProviderType;
	providerName: string;
	visualizationGroups: Array<{
		id: string;
		visualizationGroup: {
			name: string;
			dataSourceConfigs: Array<{
				id: string;
				sourceType: string;
				sourceConfig: Prisma.JsonValue;
				urlPath: string;
				provider: ProviderType;
			}>;
		};
	}>;
	workflowTriggerType?: WorkflowTriggerType;
}

export interface GenerateDataUpdateStepsInput {
	visualizationGroups: Array<{
		id: string;
		visualizationGroup: {
			name: string;
			dataSourceConfigs: Array<{
				id: string;
				sourceType: string;
				sourceConfig: Prisma.JsonValue;
				urlPath: string;
				provider: ProviderType;
			}>;
		};
	}>;
	providerType: any;
	providerName: string;
	workspaceId: string;
	startingOrder: number;
	workflowTriggerType: WorkflowTriggerType;
}

export interface CustomWorkflowMetadata {
	scheduledWorkflowId: string;
	viewVisualizationGroupIds?: string[];
	viewVisualizationGroupId?: string;
	taskName?: string;
	providerType?: ProviderType;
	tierSyncPausedAt?: string;
	legacyAutoSyncPausedAt?: string;
}
